import { put, call, takeLatest } from 'redux-saga/effects';
import {
  FETCH_LANGUAGE_LIST,
  FETCH_COUNTRY_LIST,
  setLanguageList,
  setCountryList,
} from 'reducers/utils';
import {
  transform,
  transformCountryList,
  transformLanguageList,
} from 'utils/DataTransform/utils';
import API from 'services/api';
import { showSnackbar } from 'reducers/ui';
import { errorHandler } from 'utils/errorMessages';

export function* fetchCountryList() {
  try {
    const { data } = yield call(API.getCountryList);
    const countries = data.data;
    const countryCode = transform(countries, 'dialCode');
    yield put(setCountryList(transformCountryList(countries), countryCode));
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}
export function* fetchLanguageList() {
  try {
    const { data } = yield call(API.getLanguageList);
    const languages = data.data;
    const dictionary = transform(languages, 'name');
    yield put(setLanguageList(transformLanguageList(languages), dictionary));
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}

export function* utilSagas() {
  yield takeLatest(FETCH_COUNTRY_LIST, fetchCountryList);
  yield takeLatest(FETCH_LANGUAGE_LIST, fetchLanguageList);
}
